import _ from 'lodash';
import i18n from '@/i18n';

export interface IOrder {
  id: number,
  reference: String,
  date: Date,
  shipping: String,
  price: number,
  currency: String
};

export class Order implements IOrder {
  id: number = 0;
  reference: String = '';
  date: Date = new Date();
  shipping: String = '';
  price: number = 0;
  currency: String = '';

  constructor(raw: any) {
    this.id = Number.parseInt(raw.id);
    this.reference = _.get(raw, 'reference', '');
    this.date = new Date(raw.date);
    this.shipping = _.get(raw, 'shipping', '');
    this.price = Number.parseFloat(raw.price);
    this.currency = _.get(raw, 'currency', '');
  }
}

export interface IAttribute {
  name: string,
  value: string
}

export interface IProduct {
  id: string,
  index: string,
  name: string,
  image: string,
  quantity: number,
  ean: string,
  attributes: Array<IAttribute>
}

export function isProduct(obj: any): obj is IProduct {
  return true
    && _.has(obj, 'id')
    && _.has(obj, 'index')
    && _.has(obj, 'ean')
    && _.has(obj, 'name')
    && _.has(obj, 'image')
    && _.has(obj, 'quantity')
    && _.has(obj, 'attributes')
  ;
}

export interface IOrderProductsDict {
  [idProduct: string]: IProduct
}

export interface IOrderDetails extends IOrder {
  products: IOrderProductsDict
}

export class Attribute implements IAttribute {
  name: string = '';
  value: string = '';

  constructor(raw: any) {
    this.name = _.get(raw, 'name', '');
    this.value = _.get(raw, 'value', '');
  }
}

export class Product implements IProduct {
  id: string = "0";
  index: string = '';
  name: string = '';
  image: string = '';
  quantity: number = 1;
  attributes: Array<IAttribute> = [];
  ean: string = '';

  constructor(raw: any) {
    this.id = _.toString(_.get(raw, 'id', '0'));
    this.name = _.get(raw, 'name', '');
    this.index = _.get(raw, 'index', '');
    this.image = _.get(raw, 'image', '');
    this.quantity = _.get(raw, 'quantity', 1);
    this.ean = _.get(raw, 'ean', '');
    if (_.has(raw, 'color')) {
      this.attributes.push(new Attribute({
        name: _.toString(i18n.t('general.color')),
        value: _.get(raw, 'color')
      }));
    }
    if (_.has(raw, 'size')) {
      this.attributes.push(new Attribute({
        name: _.toString(i18n.t('general.size')),
        value: _.get(raw, 'size')
      }));
    }
    if (_.has(raw, 'attributes')) {
      _.each(_.get(raw, 'attributes', []), (attribute) => {
        this.attributes.push(new Attribute(attribute));
      });
    }
  }
}

export class OrderDetails extends Order implements IOrderDetails {
  products: IOrderProductsDict = {};

  constructor(raw: any) {
    super(raw);
    _.each(_.get(raw, 'products', []), (raw) => {
      const product = new Product(raw);
      this.products[product.id] = product;
    });
  }
}

export interface IOrderProductsMap {
  [index: string]: string
}

export enum ChangeStatusResult {
  Ok = 'ok',
  Error = 'error',
  NotExists = 'not_exists',
  ConnectionLost = 'connection_lost',
}